import { Student } from '@/common/types/student';
import React from 'react';
import { renderToString } from 'react-dom/server';
import QRCode from 'react-qr-code';

export default async function generateLoginCards(students: Student[]) {
  // Generate QR code SVG as string
  const generateQRCodeSVG = (url: string) => {
    const qrCodeElement = React.createElement(QRCode, {
      value: url,
      size: 100,
      style: { height: '80px', width: '80px' },
      bgColor: '#FFFFFF',
      fgColor: '#000000',
      level: 'M',
    });
    return renderToString(qrCodeElement);
  };

  const studentAuthUrl = 'https://app.spellcaster.education/game/login';

  const printFrame = document.createElement('iframe');
  printFrame.style.position = 'fixed';
  printFrame.style.right = '0';
  printFrame.style.bottom = '0';
  printFrame.style.width = '0';
  printFrame.style.height = '0';
  printFrame.style.border = 'none';

  document.body.appendChild(printFrame);

  const html = `
    <!DOCTYPE html>
    <html>
    <head>
      <title>Spellcaster Logins</title>
      <style>
        @media print {
          @page { margin: 0.5cm; }
          body { margin: 0; }
        }
        body { 
          font-family: Arial, sans-serif;
          background: #f9f9f9;
        }
        .container { 
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 20px;
          padding: 20px;
        }
        .card {
          background: white;
          border: 2px solid #e2e8f0;
          border-radius: 8px;
          padding: 20px;
          page-break-inside: avoid;
          box-shadow: 0 2px 4px rgba(0,0,0,0.05);
          position: relative;
          min-height: 200px;
          display: flex;
          flex-direction: column;
        }
        .logo {
          width: 120px;
          position: absolute;
          top: 20px;
          right: 20px;
          object-fit: contain;
          margin-bottom: 8px;
        }
        .field {
          margin: 12px 0;
          border-bottom: 1px dotted #e2e8f0;
          padding-bottom: 8px;
        }
        .label {
          font-weight: bold;
          color: #64748b;
          font-size: 0.9em;
          text-transform: uppercase;
          letter-spacing: 0.05em;
        }
        .value {
          color: #1e293b;
          font-size: 1.1em;
          margin-top: 4px;
        }
        .card-footer {
          display: flex;
          align-items: center;
          margin-top: auto;
          padding-top: 10px;
        }
        .qr-code {
          width: 80px;
          height: 80px;
          background: white;
          padding: 5px;
        }
        .qr-text {
          margin-left: 10px;
          font-size: 0.8em;
          color: #64748b;
        }
      </style>
    </head>
    <body>
      <div class="container">
        ${students
          .map(
            (student) => `
          <div class="card">
            <img src="https://app.spellcaster.education/ui/new-spellcaster-logo.svg" class="logo" alt="Spellcaster Logo" />
            <div class="field">
              <div class="label">Name</div>
              <div class="value">${student.studentFirstName} ${
              student.studentSurname
            }</div>
            </div>
            <div class="field">
              <div class="label">Username</div>
              <div class="value">${student.spellcastUsername}</div>
            </div>
            <div class="field">
              <div class="label">Password</div>
              <div class="value">${student.password}</div>
            </div>
            <div class="card-footer">
              <div class="qr-code">
                ${generateQRCodeSVG(studentAuthUrl)}
              </div>
              <div class="qr-text">Scan to login to Spellcaster, or navigate to spellcaster.education and click Learner Login</div>
            </div>
          </div>
        `,
          )
          .join('')}
      </div>
    </body>
    </html>
  `;

  const doc = printFrame.contentWindow?.document;
  if (!doc) return;

  doc.open();
  doc.write(html);
  doc.close();

  // Give a small delay to ensure content is rendered
  setTimeout(() => {
    printFrame.contentWindow?.print();
    setTimeout(() => {
      document.body.removeChild(printFrame);
    }, 100);
  }, 100);
}
